/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hc_Domains_QuestionInputs */

const en_hc_domains_question = /** @type {(inputs: Hc_Domains_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do custom domains work?`)
};

const es_hc_domains_question = /** @type {(inputs: Hc_Domains_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo funcionan los dominios personalizados?`)
};

const fr_hc_domains_question = /** @type {(inputs: Hc_Domains_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment fonctionnent les domaines personnalisés ?`)
};

const de_hc_domains_question = /** @type {(inputs: Hc_Domains_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie funktionieren benutzerdefinierte Domains?`)
};

/** @type {(inputs: Hc_Domains_QuestionInputs) => LocalizedString} */
const ja_hc_domains_question = en_hc_domains_question;

/** @type {(inputs: Hc_Domains_QuestionInputs) => LocalizedString} */
const zh_hc_domains_question = en_hc_domains_question;

/** @type {(inputs: Hc_Domains_QuestionInputs) => LocalizedString} */
const ar_hc_domains_question = en_hc_domains_question;

/** @type {(inputs: Hc_Domains_QuestionInputs) => LocalizedString} */
const id_hc_domains_question = en_hc_domains_question;

/** @type {(inputs: Hc_Domains_QuestionInputs) => LocalizedString} */
const it_hc_domains_question = en_hc_domains_question;

/** @type {(inputs: Hc_Domains_QuestionInputs) => LocalizedString} */
const ru_hc_domains_question = en_hc_domains_question;

/** @type {(inputs: Hc_Domains_QuestionInputs) => LocalizedString} */
const pt_hc_domains_question = en_hc_domains_question;

/** @type {(inputs: Hc_Domains_QuestionInputs) => LocalizedString} */
const ko_hc_domains_question = en_hc_domains_question;

/**
* | output |
* | --- |
* | "How do custom domains work?" |
*
* @param {Hc_Domains_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const hc_domains_question = /** @type {((inputs?: Hc_Domains_QuestionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hc_Domains_QuestionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hc_domains_question(inputs)
	if (locale === "es") return es_hc_domains_question(inputs)
	if (locale === "fr") return fr_hc_domains_question(inputs)
	if (locale === "de") return de_hc_domains_question(inputs)
	if (locale === "ja") return ja_hc_domains_question(inputs)
	if (locale === "zh") return zh_hc_domains_question(inputs)
	if (locale === "ar") return ar_hc_domains_question(inputs)
	if (locale === "id") return id_hc_domains_question(inputs)
	if (locale === "it") return it_hc_domains_question(inputs)
	if (locale === "ru") return ru_hc_domains_question(inputs)
	if (locale === "pt") return pt_hc_domains_question(inputs)
	return ko_hc_domains_question(inputs)
});